// extracted by mini-css-extract-plugin
module.exports = {"container":"e462cbfa4b--container--V5EgS"};